import React from 'react'
import _ from 'lodash'

const workLocationIcons = [
  { location: 'on_site', icon: 'lnr-apartment' },
  { location: 'remote', icon: 'lnr-laptop' },
  { location: 'in_house', icon: 'lnr-home' }
]

const CustomEvent = ({ event }) => (
  <div>
    <span
      className={`lnr ${_.get(_.find(workLocationIcons, object => (object.location === event.meta.work_location)), 'icon')}`}
    />

    {event.title}

    {(_.get(event, 'meta.klass_name') === 'Task' || _.get(event, 'meta.event_type') === 'task') && (
      <span
        className={`lnr lnr-checkmark-circle lnr--${_.get(event, 'meta.completed') ? 'green-bright' : 'white'} lnr--large`}
        style={{ float: 'right', fontWeight: 600 }}
      />
    )}
  </div>
)

export default CustomEvent
